<template>
    <section class="custom_page_v2 first_page" >

      <div class="section_no_background">
        <div class="">

          <loading-block v-if="islogin==false" :loading="!islogin"/>

          <div class="container-fluid" v-if="islogin">

            <div class="section_no_background">
              <div class=" mb-3 ">
                <div class="col-12  text-left">
                  <p><router-link tag="a" v-if="user.isshop=1" class="btn" :to="{name: 'add_item'}">
                    Добавить товар
                  </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid" v-if="islogin && data.length>0" >
            <div class="mt-1 section_gray_bg mobile_div" v-for="(row,row_index) in data" :key="data.last_id">
              <div class="row m-1 mobile_div">
                <div class="col-12 col-lg-6 col-md-6">
                  <p>{{ row.title }}</p>
                  <p>{{ row.category.title }}</p>
                  <p>{{ row.price}} {{ row.currency}}</p>
                </div>
                <div class="col-12 col-lg-6 col-md-6 mt-1">
                  <p v-if="row.enable==1">отображается</p>
                  <p v-if="row.enable==0">скрыт</p>
                  <p><router-link tag="a" v-if="user.isshop=1" class="btn btn-sm" :to="{name: 'edit_item',params:{id:row.last_id}}">
                    Редактировать
                  </router-link></p>


                </div>
              </div>

            </div>
            <div class="row col-12  second_section d-flex align-items-center justify-content-center" v-if="total>offset">
              <div class="row second_section d-flex justify-content-center">
                <button class="btn" @click="load">Загрузить еще</button>

              </div>
            </div>
          </div>



        </div></div></section>


</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Modal from "@/components/Modal";
import Api from "@/models/Api";
import UserModel from "@/models/UserModel.js";
import LoadingBlock from "@/components/Custom/LoadingBlock";


export default {
  name: "ManageItems",

  data() {
    var app = this;
    return {
      "user":{},
      "limit":20,
      "offset":0,
      "islogin":false,
      "is_load":false,
      "modal_title": "Добавить товар",
      "iserror": false,
      "error_message": null,
      "newItem": {
        "new_option":{
          "title":"",
          "price":0,
        },
        "title":null,
        "currency":"RUB",
        "price":null,
        "islimited":false,
        "count":0,
        "photos":[],
        "options":[],
        "content_json":[],
        "category": null,
        'json': null,

      },
      "currencys_title":[],
      "type_currencys":[],
      "loaded_categorys": false,
      "categorys": null,
      'modals': {
        "add": null,
      },
      data: [],
      selected: null,
      defaultOpenedDetails: [],
      showDetailIcon: true,


    }
  },

  mounted: function () {
    var app=this;


    var user=UserModel.get();






    app.user=user;
    Api.loadShopCategorys(function(data){
      app.categorys=data.categorys;
      app.loaded_categorys=true;
      app.islogin = true;

    });
    app.load();













  },
  methods: {
    load(){
      var app=this;
      Api.loadShopItems(app.limit,app.offset,function(data){
        app.data = app.data.concat(data.items);
        app.offset=data.offset;
        app.total=data.total;
      });
    },
    editItem(index){
      var app=this;
      var newitem=this.data[index];
      var params = {

        type: "edititem",
        "categorys":app.categorys,
        isshop: true,
        newItem:newitem,
        json: newitem.content_json

      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    addItem() {
      var app=this;


      var params = {

        type: "additem",
        "categorys":app.categorys,
        isshop: true,
            "newItem": {
              "title":null,
              "currency":"RUB",
              "price":null,
              "islimited":false,
              "count":0,
              "photos":[],
              "options":[],
              "content_json":[],
              "category": null,
              'json': null,
              'enable':true,

            },
        modal_title: "Добавить товар",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Детальное описание товара",
              "level": 2
            }
          }]
        }
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }


    },

    deleteWork(parameter, par2) {

    },
    clickRow(row) {

    },
    onSubmit(event) {


    },

  },

  components: {Modal,LoadingBlock}
};
</script>